(ns ui.data-grid.column-resize
  (:require
   [applied-science.js-interop :as j]
   [react :as react]))

(defn use-auto-size-toggle [whole-table-selected?]
  (let [collapsed-widths-ref (react/useRef (js/Map.))
        auto-sized-widths-ref (react/useRef (js/Map.))
        dragging-ref          (react/useRef (js/Set.))]
    {:on-grid-ready
     (fn [event]
       (let [collapsed-widths (j/get collapsed-widths-ref :current)]
         (doseq [column (j/call (j/get event :api) :getColumns)]
           (.set collapsed-widths
                 (j/call column :getColId)
                 (j/call column :getActualWidth)))))

     :on-column-resized
     (fn [event]
       (when (= "uiColumnResized" (j/get event :source))
         (let [event-columns     (j/get event :columns)
               columns           (or (seq event-columns)
                                     (some-> (j/get event :column) vector)
                                     [])
               finished          (j/get event :finished)
               collapsed-widths  (j/get collapsed-widths-ref :current)
               auto-sized-widths (j/get auto-sized-widths-ref :current)
               dragging          (j/get dragging-ref :current)]
           (doseq [column columns]
             (let [column-id    (j/call column :getColId)
                   actual-width (j/call column :getActualWidth)]
               (cond
                 (not finished)
                 (.add dragging column-id)

                 (.has dragging column-id)
                 (do
                   (.delete dragging column-id)
                   (.set collapsed-widths column-id actual-width)
                   (.delete auto-sized-widths column-id))

                 whole-table-selected?
                 (j/call (j/get event :api) :autoSizeAllColumns)

                 :else
                 (let [auto-sized-width (.get auto-sized-widths column-id)]
                   (if (and (some? auto-sized-width)
                            (<= (js/Math.abs (- actual-width auto-sized-width)) 1))
                     (do
                       (.delete auto-sized-widths column-id)
                       (j/call (j/get event :api)
                               :setColumnWidths
                               #js [#js {:key column
                                         :newWidth (.get collapsed-widths column-id)}]
                               true
                               "api"))
                     (do
                       (when-not (.has collapsed-widths column-id)
                         (.set collapsed-widths column-id
                               (or (j/get (j/call column :getColDef) :width)
                                   actual-width)))
                       (.set auto-sized-widths column-id actual-width))))))))))}))
